export default function unixTimeToDateTime(unixTime: number): string {
  var dateObject = new Date(1000*unixTime);
  dateObject.setHours(
    dateObject.getHours()
    + dateObject.getTimezoneOffset() / 60
  );

  return dateObject.toLocaleString("es-cl");
}